<!-- @veltra/icons generated sha256:54729d4b3d8fcad3 gen:8 source:src/svg/normal/refresh.svg -->
<script setup lang="ts">
defineOptions({ name: 'Refresh' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M13.232 7.519C12.992 4.819 10.736 2.71 8 2.71a5.25 5.25 0 0 0-4.51 2.574h1.358c.266 0 .489.201.489.468v.01a.48.48 0 0 1-.477.486H2.256a.5.5 0 0 1-.506-.494V3.122c0-.264.2-.48.465-.48h.01a.49.49 0 0 1 .484.49V4.72A6.2 6.2 0 0 1 8 1.75c3.272 0 5.953 2.542 6.197 5.768a.456.456 0 0 1-.466.48h-.011c-.266 0-.464-.215-.488-.48m-10.951.48H2.27a.457.457 0 0 0-.466.48c.244 3.227 2.925 5.768 6.196 5.768a6.2 6.2 0 0 0 5.291-2.97v1.59c0 .264.218.488.476.488a.483.483 0 0 0 .483-.48v-2.632a.5.5 0 0 0-.506-.495H11.14a.48.48 0 0 0-.477.486v.01c0 .267.223.468.49.468h1.357A5.25 5.25 0 0 1 8 13.286c-2.736 0-4.99-2.108-5.232-4.807-.023-.265-.222-.48-.487-.48"
    />
  </svg>
</template>
